<div class="footer-info">
    <mat-divider></mat-divider>
    <div class="center">
        <a href="{{odrlink?.link}}" target="_blank">Update My Directory Listing</a> &nbsp;|&nbsp;
        <a href="https://www.ucdavis.edu/emergency" target="_blank">Emergency/Continuity Management</a> &nbsp;|&nbsp;
        <a href="https://safetyservices.ucdavis.edu/" target="_blank">Safety Services</a>
    </div>
    <p class="center-copyright">Copyright © The Regents of the University of California, Davis campus. All Rights Reserved.</p>
</div>
